export default __webpack_public_path__ + "static/media/grey-background-tint.af05336e.png";